<template>
  <div>
    <header-applis titre="Connaître votre projet" index-progression-courante="1"/>
    <div class="container-flex-select">
      <button @click="choixSelectionne = 1" :class="(choixSelectionne === 1) ? 'actif' : ''" class="button-app big-button">
        J’ai identifié le diplôme et/ou la formation en lien avec mon projet
      </button>
      <button @click="choixSelectionne = 2" :class="(choixSelectionne === 2) ? 'actif' : ''" class="button-app big-button">
        Je n’ai pas identifié le diplôme et/ou la formation, mais je connais le domaine et le niveau en lien avec mon projet
      </button>
      <button @click="choixSelectionne = 3" :class="(choixSelectionne === 3) ? 'actif' : ''" class="button-app big-button">
        Je n’ai pas encore finalisé mon projet, ni ciblé de formation ou de diplôme précis
      </button>
      <p>
        Pour évoluer dans cet outil, nous vous conseillons d’avoir exploré notre offre universitaire : <a href="https://fc.univ-nantes.fr/" target="_blank">https://fc.univ-nantes.fr/</a>
        <br/>
        Dans la situation où votre projet conduit à cibler plusieurs diplômes et/ou formations, vous êtes invité à réitérer votre démarche autant de fois
      </p>
    </div>
    <div class="wrapper__content">
      <div v-if="choixSelectionne === 1">
        <p>Veuillez saisir l’intitulé du diplôme et/ou de la formation&nbsp;:</p>
        <div class="autocomplete">
          <div class="search-input__wrapper">
            <span class="ico-search__wrapper"><i class="ico-search"></i></span>
            <input type="text" v-model="search" @input="onChangeAutocomplete"/>
          </div>
          <div v-show="estFormationSelectionnee" class="app-formation-selectionnee">
            <h4>Formation sélectionnée :</h4>
            <h5>{{ diplomeChoisi.intituleLong }}</h5>
            <div v-show="estFormationSelectionnee && diplomeChoisi.parcours.length > 0">
              <parcours :parcours-list="diplomeChoisi.parcours"/>
            </div>
          </div>
          <div v-show="erreurAucuneFormation">
            <p>Aucune formation correspond à votre recherche.</p>
          </div>
          <div>
            <div v-show="this.formationsCorrespondantes.length > 0" class="app-item-resulat-recherche">
              <button class="button-app fake-button" type="button" @click.prevent="selectionnerFormation(formation)" v-for="formation in formationsCorrespondantes"
                      :key="formation.code">
                <h5>{{ formation.intituleLong }}</h5>
                <div v-show="formation.parcours.length > 0" class="liste-parcours">
                  <parcours :parcours-list="formation.parcours"/>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="choixSelectionne === 2" class="app-container-flex">
        <select v-model="domaineFormation" class="app-item-select" @change="selectionnerDomaineFormation">
          <option disabled value="">Sélectionnez un domaine de formation</option>
          <option value="D01">Droit</option>
          <option value="D02">Économie - Gestion - Management</option>
          <option value="D03">Enseignement</option>
          <option value="D04">Génie civil</option>
          <option value="D05">International</option>
          <option value="D06">Lettres - Langues - Communication</option>
          <option value="D07">Mathématiques</option>
          <option value="D07">Numérique - Électronique</option>
          <option value="D09">Physique - Chimie - Génie des procédés</option>
          <option value="D10">Santé</option>
          <option value="D11">Sciences Humaines et Sociales</option>
          <option value="D12">Sciences de la Vie</option>
          <option value="D13">STAPS</option>
          <option value="D14">Technologies</option>
          <option value="D15">Qualité - Logistique - Maintenance</option>
          <option value="D15">Qualité - Logistique - Maintenance</option>
          <option value="D16">Sciences de la Terre et de l'Univers (STU)</option>
          <option value="D17">Mécanique - Matériaux</option>
        </select>

        <select v-if="domaineFormation" v-model="typeFormation" class="app-item-select" @change="selectionnerTypeFormation">
          <option disabled value="">Sélectionnez un type de formation</option>
          <optgroup id="opt10000" label="Niveau Licence">
            <option value="12000" title="DUT">DUT</option>
            <option value="13000" title="Licence">Licence</option>
            <option value="15000" title="Licence Professionnelle">Licence Professionnelle</option>
          </optgroup>
          <optgroup id="opt20000" label="Niveau Master">
            <option value="21000" title="Ingénieur">Ingénieur</option>
            <option value="25000" title="Master">Master</option>
            <option value="26000" title="Master MEEF">Master MEEF</option>
          </optgroup>
          <optgroup id="opt30000" label="Niveau Doctorat">
            <option value="31000" title="Attestation de Formation Spécialisée Approfondie">Attestation de Formation Spécialisée Approfondie</option>
            <option value="32000" title="Capacité médecine">Capacité médecine</option>
            <option value="33000" title="DES médecine">DES médecine</option>
            <option value="34000" title="DES pharmacie">DES pharmacie</option>
            <option value="35000" title="Dip Etudes Spéc Compl médecine">Dip Etudes Spéc Compl médecine</option>
            <option value="36000" title="Dip Etudes Spéc Complémentaire pharmacie">Dip Etudes Spéc Complémentaire pharmacie</option>
            <option value="37000" title="Diplôme d'Etat de docteur en Médecine">Diplôme d'Etat de docteur en Médecine</option>
            <option value="38000" title="Diplôme d'Etat de docteur en Pharmacie">Diplôme d'Etat de docteur en Pharmacie</option>
            <option value="39000" title="Diplôme de recherche technologique (DRT)">Diplôme de recherche technologique (DRT)</option>
            <option value="39100" title="Doctorat">Doctorat</option>
            <option value="39200" title="Doctorat d'état">Doctorat d'état</option>
            <option value="39300" title="Habilitation à Diriger des Recherches">Habilitation à Diriger des Recherches</option>
          </optgroup>
          <optgroup id="opt40000" label="Concours">
            <option value="41000" title="Concours de l'enseignement">Concours de l'enseignement</option>
            <option value="42000" title="Concours administratifs">Concours administratifs</option>
            <option value="43000" title="Concours de la magistrature">Concours de la magistrature</option>
          </optgroup>
          <optgroup id="opt50000" label="Autres formations">
            <option value="51000" title="Capacité">Capacité</option>
            <option value="52000" title="Certificat">Certificat</option>
            <option value="53000" title="DAEU">DAEU</option>
            <option value="54000" title="Diplôme d'université">Diplôme d'université</option>
            <option value="55000" title="Formation continue non diplômante">Formation continue non diplômante</option>
            <option value="56000" title="Mastères spécialisés">Mastères spécialisés</option>
          </optgroup>
          <optgroup id="opt60000" label="Santé">
            <option value="61000" title="Santé - Cycle 1 (Médecine, odontologie, Pharmacie, Maïeutique)">Santé - Cycle 1 (Médecine, odontologie, Pharmacie, Maïeutique)</option>
            <option value="61001" title="Premier cycle : Médecine, odontologie, pharmacie, maïeutique">Premier cycle : Médecine, odontologie, pharmacie, maïeutique</option>
            <option value="62000" title="Santé - Cycle 2 (Médecine, odontologie, Pharmacie, Maïeutique)">Santé - Cycle 2 (Médecine, odontologie, Pharmacie, Maïeutique)</option>
            <option value="63000" title="Santé - Cycle 3 (DES, DESC, CES, Capacité)">Santé - Cycle 3 (DES, DESC, CES, Capacité)</option>
          </optgroup>
        </select>
      </div>
    </div>
    <footer-applis ecran-precedent="/recueilinfos" :ecran-suivant="ecranSuivant" labelSuivant="Je confirme et je passe à la suite"/>
  </div>
</template>

<script>
import apiService from '../services/ApiService';
import HeaderApplis from '../components/HeaderApplis';
import FooterApplis from '../components/FooterApplis';
import Parcours from '../components/Parcours';

export default {
  name: 'choixprojet',
  components: {
    Parcours,
    FooterApplis,
    HeaderApplis
  },
  data: function () {
    return {
      diplomeChoisi: {},
      search: '',
      formationsCorrespondantes: [],
      choixSelectionne: 0,
      erreurAucuneFormation: false,
      domaineFormation: '',
      typeFormation: '',
      objetDomaineFormation: {},
      objetTypeFormation: {}
    };
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    },
    /**
     * Permet de savoir si une formation a été sélectionnée.
     * @returns {boolean} Vrai si une formation a été sélectionnée, sinon faux.
     */
    estFormationSelectionnee() {
      return Object.entries(this.diplomeChoisi).length > 0;
    },
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     * @param nomEcranSuivant Le nom de l'écran suivant.
     */
    ecranSuivant() {
      let nomEcran = '';
      if (this.choixSelectionne === 1 && this.estFormationSelectionnee) {
        nomEcran = 'confirmation';
      } else if (this.choixSelectionne === 2 && this.domaineFormation && this.typeFormation) {
        this.$store.commit('setDomaineFormation', this.objetDomaineFormation);
        this.$store.commit('setTypeFormation', this.objetTypeFormation);
        nomEcran = 'rechercheformation';
      } else if (this.choixSelectionne === 3) {
        nomEcran = 'choixstatut';
      }
      return nomEcran;
    }
  },
  methods: {
    save() {
      this.$store.commit('setDiplomeChoisi', this.diplomeChoisi);
    },
    /**
     * Méthode appelée au changement de valeur de l'input d'autocomplete.
     * Requête de l'API de recherche pour récupérer les formations correspondantes à la valeur saisie.
     */
    onChangeAutocomplete() {
      if (this.estFormationSelectionnee) {
        this.diplomeChoisi = {};
        this.save();
      }
      this.formationsCorrespondantes = [];
      if (this.search.length >= 3) {
        apiService.search(this.search)
            .then(formations => this.mettreAJourFormationsCorrespondantes(formations))
            .catch(console.error);
      }
    },
    mettreAJourFormationsCorrespondantes(formations) {
      this.formationsCorrespondantes = formations;
      this.erreurAucuneFormation = this.formationsCorrespondantes.length === 0;
    },
    /**
     * Méthode appelée lors de la sélection d'une formation.
     * @param formationSelectionnee Le JSON correspondant à la formation sélectionnée.
     */
    selectionnerFormation(formationSelectionnee) {
      this.diplomeChoisi = formationSelectionnee;
      this.save();
      this.formationsCorrespondantes = [];
    },
    /**
     * Méthode peu élégante, permet la récupération de la valeur du libellé  du domaine de formation afin de pouvoir la stocker dans le store et l'envoyer dans le récapitulatif.
     */
    selectionnerDomaineFormation(e) {
      this.objetDomaineFormation.code = e.target.value;
      let element = e.target.querySelector('[value="' + e.target.value + '"]');
      this.objetDomaineFormation.libelle = element.innerHTML;
    },
    /**
     * Méthode peu élégante, permet la récupération de la valeur du libellé  du type de formation afin de pouvoir la stocker dans le store et l'envoyer dans le récapitulatif.
     */
    selectionnerTypeFormation(e) {
      this.objetTypeFormation.code = e.target.value;
      let element = e.target.querySelector('[value="' + e.target.value + '"]');
      this.objetTypeFormation.libelle = element.innerHTML;
    }
  },
  created() {
    this.diplomeChoisi = this.informationsParcours.diplomeChoisi;
    this.domaineFormation = this.informationsParcours.domaineFormation.code;
    this.typeFormation = this.informationsParcours.typeFormation.code;
    this.objetDomaineFormation = this.informationsParcours.domaineFormation;
    this.objetTypeFormation = this.informationsParcours.typeFormation;
  }
}
</script>

<style scoped>


.autocomplete input {
  width: 100%;
}

button.fake-button:hover {
  background-color: #E3E3E3;
}

button:active {
  box-shadow: none;
}

button.button.actif {
  background-color: #515961;
  color: #fff;
}

.liste-parcours {
  color: #515961;
  font-size: 1rem;
}

#appcompetences--widget .fake-button.fake-button,
#appcompetences--widget .app-formation-selectionnee {
  border: none;
  border-bottom: 1px solid lightgrey;
  width: 100%;
  text-align: initial;
  background-color: #f9f9f9;
  padding: .8rem 1rem;
  cursor: pointer;
}

.app-container-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.app-item-select {
  width: 100%;
  margin-bottom: 1em;
  box-sizing: border-box;
}

@media (min-width: 932px) {
  .app-item-select {
    width: 48%;
  }
}

.search-input__wrapper {
  position: relative;
}

.ico-search__wrapper {
  position: absolute;
  right: .5em;
  top: .6em;
}

.ico-search {
  pointer-events: none;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  font-style: normal;
  color: #515961;
  text-align: left;
  text-indent: -9999px;
  direction: ltr;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin: 4px 4px 8px 8px;
  border: 2px solid #515961;
}

.ico-search::before,
.ico-search::after {
  content: "";
  pointer-events: none;
}

.ico-search::before {
  width: 4px;
  height: 11px;
  box-shadow: inset 0 0 0 32px;
  top: 19px;
  border-radius: 0 0 1px 1px;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);

}

</style>